<template>
  <div>
    <template v-if="!element.emphasized">
      <label class="vform-editor-label section">Bar Color</label>
      <color-picker-and-field
          :field-background-color="element.barColor"
          @saveColor="(color) => {setItemColor('barColor', color)}"
          @unsetColor="setItemColor('barColor', null)"
      />

      <label class="vform-editor-label section">Font Color</label>
      <color-picker-and-field
          :field-background-color="element.fontColor"
          @saveColor="(color) => {setItemColor('fontColor', color)}"
          @unsetColor="setItemColor('fontColor', null)"
      />

      <div
          v-if="element.barColor || element.fontColor"
          class="settings-button d-inline-block mt-2"
          @click="element.barColor = null; element.fontColor = null;">
        {{ $t('resetColor') }}
      </div>
    </template>
    <div class="col pl-0 pr-0 dflex">
      <div class="col pl-0">
        <label class="mt-3 vform-editor-label section">{{ $t("showInline") }}</label>
      </div>
      <div class="col-auto pl-0 pr-0" style="margin: auto">
        <label :for="'showInline' + $vnode.key" class="container" style="padding-left: 5px !important">
          <input :id="'showInline' + $vnode.key" v-model="element.isInline" type="checkbox">
          <span class="checkmark"/>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import {vFormControls, placeholders} from "@/enum";
import vFormElementMixin from "@/components/vForm/vFormElementMixin.js";
import ColorPickerAndField from "@/components/widgets/editors/ColorPickerAndField.vue";
export default {
  name: "vFormPROGRESS_TRACKER",
  components: {
    ColorPickerAndField,
  },
  mixins: [vFormElementMixin],
  props: {
    element: {type: Object, required: true},
    stepNo: {type: Number, required: true},
    organizationId: {type: String, default: ""},
  },
  data() {
    return {
      forceReRenderKey: 0,
      editImage: "",
      vFormControls: vFormControls,
      placeholders: placeholders,
      headingCategories: ['h1', 'h2', 'h3'],
    };
  },
  beforeMount() {
    this.element.formElementType = vFormControls["HEADLINE"];
    if (!this.element.headingCategory) {
      this.$set(this.element, "headingCategory", "h3");
    }
    if (this.element.isInline === undefined) {
      this.$set(this.element, "isInline", false);
    }
  },
  methods: {
    setCategory(val) {
        this.$set(this.element, "headingCategory", val);
    },
    save() {
      this.$emit("save", this.element);
    },
  },
};
</script>

<style lang="scss" scoped>
.vform-heading-cat-button {
  background-color: var(--vform-editor-ui-secondary-color);
  border-radius: 1px;
  margin-left: 1px;
  width: 25px;
  height: 25px;
  position: relative;
  color: #fff;
  transition: all 300ms ease;


  .size {
    vertical-align: baseline;
    font-size: 0.7rem;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    margin-top: 1px;
  }

  &.active, &:hover {
    background-color: var(--vform-editor-accent-color);
  }
}
</style>
